import { z } from 'zod';
import { cursorPageSchema, isoDateTimeSchema, uuidSchema } from './common.js';
import { importStatusSchema, importStrategySchema } from './enums.js';
import { recipeDraftSchema } from './recipe-draft.js';
import { recipeWriteInputSchema } from './recipes.js';
export const IMPORTER_VERSION = '1.0.0';
export const importUrlRequestSchema = z.object({
    url: z.string().trim().url().max(2048),
    /** Allow the AI fallback when no structured data was found. Requires consent. */
    allowAiFallback: z.boolean().default(false),
    householdId: uuidSchema.nullable().optional(),
});
export const importErrorCodeSchema = z.enum([
    'INVALID_URL',
    'BLOCKED_TARGET',
    'BLOCKED_DOMAIN',
    'ROBOTS_DISALLOWED',
    'FETCH_FAILED',
    'TIMEOUT',
    'TOO_LARGE',
    'UNSUPPORTED_CONTENT_TYPE',
    'ACCESS_PROTECTED',
    'NO_RECIPE_FOUND',
    'PARSE_FAILED',
    'RATE_LIMITED',
    'INTERNAL',
]);
export const duplicateCandidateSchema = z.object({
    recipeId: uuidSchema,
    title: z.string(),
    reason: z.enum(['SAME_CANONICAL_URL', 'SAME_FINGERPRINT', 'SIMILAR_TITLE_AND_INGREDIENTS']),
    similarity: z.number().min(0).max(1),
});
export const importJobSchema = z.object({
    id: uuidSchema,
    userId: uuidSchema,
    url: z.string(),
    canonicalUrl: z.string().nullable(),
    status: importStatusSchema,
    strategy: importStrategySchema.nullable(),
    progress: z.number().int().min(0).max(100),
    draft: recipeDraftSchema.nullable(),
    duplicates: z.array(duplicateCandidateSchema),
    errorCode: importErrorCodeSchema.nullable(),
    errorMessage: z.string().nullable(),
    importerVersion: z.string(),
    recipeId: uuidSchema.nullable(),
    createdAt: isoDateTimeSchema,
    updatedAt: isoDateTimeSchema,
    expiresAt: isoDateTimeSchema.nullable(),
});
/** Payload published on the `import:job:{id}` channel and streamed by GET /imports/:id/events. */
export const importJobEventSchema = z.discriminatedUnion('type', [
    z.object({ type: z.literal('status'), job: importJobSchema }),
    z.object({ type: z.literal('done') }),
]);
export const importJobPageSchema = cursorPageSchema(importJobSchema);
export const duplicateResolutionSchema = z.enum([
    'OPEN_EXISTING',
    'UPDATE_EXISTING',
    'SAVE_AS_VARIATION',
    'SAVE_NEW',
]);
export const importConfirmRequestSchema = z.object({
    /** The reviewed and possibly corrected recipe. */
    recipe: recipeWriteInputSchema,
    duplicateResolution: duplicateResolutionSchema.default('SAVE_NEW'),
    existingRecipeId: uuidSchema.nullable().optional(),
    /** Copy the remote cover image into our storage (rights confirmed by the user). */
    copyRemoteImage: z.boolean().default(false),
});
export const importConfirmResponseSchema = z.object({
    recipeId: uuidSchema,
    action: duplicateResolutionSchema,
});
export const importOwnJsonRequestSchema = z.object({
    recipes: z.array(recipeWriteInputSchema).min(1).max(500),
    skipDuplicates: z.boolean().default(true),
});
export const importOwnJsonResponseSchema = z.object({
    created: z.number().int(),
    skipped: z.number().int(),
    recipeIds: z.array(uuidSchema),
});
//# sourceMappingURL=imports.js.map